import { render, staticRenderFns } from "./Fontosak.vue?vue&type=template&id=49c82970&"
import script from "./Fontosak.vue?vue&type=script&lang=js&"
export * from "./Fontosak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports